<template>
  <section class="update-platform-coupon">
    <div @click="goBack" class="go-back">>返回</div>
    <el-form
      label-width="100px"
      size="mini"
      ref="merchant"
      :model="formData"
      :rules="rules"
      class="form"
    >
      <el-form-item label="优惠券类型" prop="type" class="coupon-type">
        <el-select
          v-model="formData.discountsBaseId"
          placeholder="请选择优惠券类型"
          @change="onCouponChange"
          :disabled="type==='edit'"
        >
          <el-option
            v-for="{ couponName, discountsId } in couponTypesData"
            :value="discountsId"
            :key="discountsId"
            :label="couponName"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="优惠券名称" prop="name" class="coupon-name">
        <el-input v-model="formData.name"></el-input>
      </el-form-item>
    </el-form>

    <reduct-frequency
      ref="desc"
      v-if="couponType === 'ReductFrequency'"
      :coupon="coupon"
      :type="type"
    ></reduct-frequency>
    <cash
      ref="desc"
      v-if="couponType === 'Cash'"
      :coupon="coupon"
      :type="type"
    ></cash>
    <discount
      ref="desc"
      v-if="couponType === 'Discount'"
      :coupon="coupon"
      :type="type"
    ></discount>
    <fix-time-and-quota
      ref="desc"
      v-if="couponType === 'FixTimeAndQuota'"
      :coupon="coupon"
      :type="type"
    ></fix-time-and-quota>
    <limit-free
      ref="desc"
      v-if="couponType === 'LimitFree'"
      :coupon="coupon"
      :type="type"
    ></limit-free>
    <quota
      ref="desc"
      v-if="couponType === 'Quota'"
      :coupon="coupon"
      :type="type"
    ></quota>
    <reduct-time
      ref="desc"
      v-if="couponType === 'ReductTime'"
      :coupon="coupon"
      :type="type"
    ></reduct-time>
    <el-button type="primary" class="submit-button" @click="onSubmitBtn"
      >确定</el-button
    >
  </section>
</template>
<script>
import { getCouponType, updateCoupon } from "@/api/url";
import ReductFrequency from "../../../components/ReductFrequency/ReductFrequency.vue";
import Cash from "../../../components/Cash/Cash.vue";
import Discount from "../../../components/Discount/Discount.vue";
import FixTimeAndQuota from "../../../components/FixTimeAndQuota/FixTimeAndQuota.vue";
import LimitFree from "../../../components/LimitFree/LimitFree.vue";
import Quota from "../../../components/Quota/Quota.vue";
import ReductTime from "../../../components/ReductTime/ReductTime.vue";
import { COUPON_TYPE } from "../../../constant.js";
export default {
  name: "merchant-update",
  props: {},
  data() {
    return {
      formData: {
        name: "",
        discountsBaseId: "0f66c02167b042c4a08a88b700d2fb7b",
      },
      rules: {},

      couponTypesData: "",
      couponType: "ReductTime",
      shopsId: "",
      type: "",
      coupon: null,
      couponShopId:''
      
    };
  },
  components: {
    ReductFrequency,
    Cash,
    Discount,
    FixTimeAndQuota,
    LimitFree,
    Quota,
    ReductTime,
  },
  created() {
    this.type = this.$route.query?.type;
    this.shopsId = this.$route.query?.id;
    this.coupon = this.$route.query?.coupon??null;
    this.formData={
        name: this.$route.query?.name,
        discountsBaseId:this.$route.query?.discountsBaseId??"0f66c02167b042c4a08a88b700d2fb7b",
    }
   this.couponShopId=this.$route.query?.couponShopId;
  },
 mounted(){
    this.couponTypes();
 },
  methods: {
    couponTypes() {
      this.$get(getCouponType()).then((data) => {
        if (data.status != 200) return;

        this.couponTypesData = data?.data?.rows ?? [];
      });
    },
    onSubmitBtn() {
      const data = JSON.parse(JSON.stringify(this.$refs.desc.getData()));
      data.type = this.couponType;
      const reqType=this.couponShopId?this.$putRequest:this.$postRequest
      reqType(this.couponShopId?`${updateCoupon()}/${this.couponShopId}`:updateCoupon(), {
        couponShopId:this.couponShopId,
        shopsId: this.shopsId,
        ...this.formData,
        couponRuleDesc: JSON.stringify(data),
      }).then((data) => {
        if (data?.status !== 200) {
          this.$message({
            type: "warning",
            message: data?.message ?? "",
          });
          return;
        }
        this.$message({
          type: "success",
          message: "添加/修改成功！",
        });
      });
    },
    onCancelBtn() {
      this.$parent.merchantUpdateCallback();
    },
    resetForm() {
      this.formData = {};
    },
    goBack() {
      this.$router.go(-1);
    },
    onCouponChange(v) {
      this.couponType = this.couponTypesData?.find(
        (c) => c.discountsId === v
      )?.couponType;
    },
  },
};
</script>
<style lang="scss">
.update-platform-coupon {
  padding: 20px;

  .form {
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    padding-top: 20px;

    .coupon-type {
      width: 49%;
    }

    .coupon-name {
      width: 49%;
    }
  }

  .submit-button {
    width: 30%;
    margin: 0 35%;
    margin-top: 40px;
    padding: 20px 0;
    font-weight: bold;
    font-size: 20px;
    letter-spacing: 50px;
  }

  .el-select {
    width: 100%;
  }

  .go-back {
    cursor: pointer;
  }
}
</style>
